"use strict";
/* IMPORT */
Object.defineProperty(exports, "__esModule", { value: true });
var channel_1 = require("./channel");
var lang_1 = require("./lang");
var unit_1 = require("./unit");
/* UTILS */
var Utils = {
    channel: channel_1.default,
    lang: lang_1.default,
    unit: unit_1.default
};
/* EXPORT */
exports.default = Utils;



//////////////////
// WEBPACK FOOTER
// ./~/khroma/dist/utils/index.js
// module id = 62
// module chunks = 0